import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { ENGLISH_LANGUAGE_CODE_LK } from '@constants';
import { localStorage } from '@utils';

const en = require('./locales/en');
const my = require('./locales/my');
const ch = require('./locales/ch');

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    EN: {
        translation: en
    },
    MM: {
        translation: my
    },
    CH: {
        translation: ch
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: ENGLISH_LANGUAGE_CODE_LK, // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

let languageTag = ENGLISH_LANGUAGE_CODE_LK;
/**
 * Get preferred language from AsyncStorage
 */
const getSavedPreference = async () => {
    try {
        const language = localStorage.getUserPreferedLanguage();
        if (language) {
            languageTag = language;
        }
    } catch (e) { }

    i18n.changeLanguage(languageTag);
};

getSavedPreference();

export default i18n;
